import React from 'react';
import { useSiteMetadata } from '../util/use-site-metadata';
import { useStrapiContext } from '../context/StrapiContext';

const Seo = ({
  title,
  description,
  main_img,
  type,
  pathname,
  keywords,
  children,
  noindex = false, // Add this new prop with a default value of false
}) => {
  const { siteUrl } = useSiteMetadata();

  const {
    metaTitle,
    metaDescription,
    keywords: defaultKeywords,
    // metaRobots,
    // metaViewport,
  } = useStrapiContext().strapiGlobal.globalSeo;

  //build the title
  const constructedTitle = title
    ? `${title} | ${metaTitle}`
    : `${metaDescription} | ${metaTitle}`;

  //build the image url
  const strapiUrl = `https://typical-courage-66f007be10.media.strapiapp.com`;

  const formatImageUrl = (url) => {
    return url.startsWith('/') ? `${strapiUrl}${url}` : url;
  };

  const imageUrl = main_img ? formatImageUrl(main_img) : ``;

  //build the meta tags
  const seo = {
    title: constructedTitle,
    description: description || metaDescription,
    image: imageUrl,
    url: `${siteUrl}${pathname || ``}`,
    type: `${type || `website`}`,
    keywords: `${keywords || defaultKeywords}`,
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    name: 'Clarity Windows and Doors',
    url: 'https://claritywindows.com/',
    logo: {
      '@type': 'ImageObject',
      url: 'https://claritywindows.com/static/7a84c58e1ace4e58143742376a44be9f/0480b/narrow_No_Bg_White_Text_765dcefac3.webp',
    },
    description:
      'Clarity Windows and Doors provides high-quality window and door replacement services for homeowners in North Texas.',
    telephone: '(972) 393 3991',
    email: 'info@claritydfw.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '800 Freeport Pkwy Suite #150',
      addressLocality: 'Coppell',
      addressRegion: 'TX',
      postalCode: '75019',
      addressCountry: 'US',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '32.9555',
      longitude: '-97.0150',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '17:00',
      },
    ],
    sameAs: [
      'https://www.facebook.com/ClarityWindowsAndDoors/',
      'https://www.linkedin.com/company/clarity-windows-and-doors',
      'https://www.youtube.com/@claritywindowsanddoors1086',
      'https://www.instagram.com/claritywindowsanddoors/',
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '423',
    },
    review: [
      {
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: 'Matt F',
        },
        datePublished: '2024-12-02',
        reviewBody:
          'This is my second time using Clarity Windows and wow they are the best. The salesman Jon Craig made the whole process easy and was very patient with us. The initial installation for our first round with Arturo was perfect, he was fast, kind, and clean. We look forward to getting our next round of windows soon!',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5',
        },
      },
      {
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: 'Shannon Yero',
        },
        datePublished: '2024-11-25',
        reviewBody:
          "Thank you, Kyle, for making our window decision easy! I'm a big researcher and spent a lot of time looking into window companies and their various products. Clarity was our last quote, after 4 other companies, most of whom did a good job with their pitches. After the consultation with Kyle, my husband and I both immediately agreed that this was the company we wanted to go with for this project. We liked that they are a small, local business, and they have their own installers. Kyle was very genuine and worked well with us in answering questions and giving us everything we needed to make the decision easy. We will update once our new windows are installed—we can't wait to see the rest of the process through with Clarity!",
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5',
        },
      },
      {
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: 'Nancy Robinson',
        },
        datePublished: '2024-11-25',
        reviewBody:
          "WOW WOW !!! I have oversized doors and had shopped for a couple of years. Looking for the perfect door and doggie door. Clarity Windows met all my expectations. Kyle from sales met with me and was able to easily guide me to the correct door for my needs. The office staff were pleasant, professional, and caring. I was kept apprised of all steps. Arturo as their team lead was simply amazing. There was quite a bit of mess (taking one door out to install the new door) but once they were done, you would never know it wasn't the original door on the house. Everything was cleaned, even my patio was swept of debris! I would recommend this company and their whole team wholeheartedly.",
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5',
        },
      },
    ],
    '@id': 'https://claritywindows.com/#HomeAndConstructionBusiness',
  };

  return (
    <>
      <html lang="en" />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="og:url" content={seo.url} />
      <meta name="og:type" content={seo.type} />

      <meta name="og:site_name" content={`${metaTitle}`} />
      <meta name="og:title" content={seo.title} />
      <meta name="og:description" content={seo.description} />
      <meta name="og:image" content={seo.image} />

      <link rel="canonical" href={seo.url} />

      {/* Add the robots meta tag */}
      <meta
        name="robots"
        content={noindex ? 'noindex, nofollow' : 'index, follow'}
      />

      {/* Add JSON-LD Schema */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      {/*BODY*/}
      {children}
    </>
  );
};

export default Seo;
